import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';


export function smallerValidator(smaller:number): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    return control.value > smaller ? {'appNotGreater': {value: control.value}} : null;
  };
}

@Directive({
  selector: '[appNotGreater]',
  providers: [{provide: NG_VALIDATORS, useExisting: SmallerDirective, multi: true}]
})

export class SmallerDirective implements Validator{
  @Input('appNotGreater') smaller: number;
 
  validate(control: AbstractControl): {[key: string]: any} {
    return this.smaller ? smallerValidator(this.smaller)(control)
                              : null;
  }

  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
  private _onChange: () => void;

  ngOnChanges(changes: SimpleChanges): void {
 
    if ('smaller' in changes) {
      
      if (this._onChange) this._onChange();
    }
  }

  

}
